<template>
    <el-dialog title="付款凭证支付" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false" width="30%">
        <el-form size="small" ref="order" :model="order" label-width="100px">
          <el-form-item label="支付凭证图片" prop="pay_image_url" :rules="[{required: true,message: '请填写支付凭证图片'}]">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="order.pay_image_url">
                <transition-group>
                  <div class="item" v-for="(item, index) in order.pay_image_url" :key="item">

                    <el-image

                       :src="item"
                       :preview-src-list="[item]">
                    </el-image>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
                  </div>
                </transition-group>
              </draggable>
              <div class="item img-select"  @click="openpayimageUpload"><i class="el-icon-plus"></i></div>
            </div>
          </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="submitFunc()" :loading="loading">审核通过</el-button>
        </div>
        <Upload v-if="ispayimageUpload" :config="{ total: 9 }" :isupload="ispayimageUpload" @returnImgs="returnpayimageImgsFunc">上传图片</Upload>
    </el-dialog>
</template>

<script>
    import OrderApi from '@/api/order.js';
    import Upload from '@/components/file/Upload';
    export default {
       components: {
        Upload
       },
        data() {
            return {
                order_id: 0,
                loading: false,
                /*左边长度*/
                formLabelWidth: '100px',
                /*是否显示*/
                dialogVisible: true,
                /*表单*/
                order: {

                    pay_image_url:[]
                },
                ispayimageUpload:false,
            };
        },
        props: ['dataModel'],
        created() {
            this.order.pay_image_url = this.dataModel.pay_image_url;

        },
        methods: {

            /*付款凭证支付提交审核*/
            submitFunc(e) {
                let self = this;
                let param = this.order;
                self.$refs.order.validate((valid) =>
                {
                    if (valid) {
                        self.loading = true;
                        OrderApi.orderPayImage({
                              pay_image_url: this.order.pay_image_url,
                              order_id: this.dataModel.order_id
                            },
                            true
                          ).then(data =>
                        {
                            self.loading = false;
                            self.$message({
                                message: '恭喜你，审核成功',
                                type: 'success'
                            });
                            self.dialogFormVisible();
                        }).catch(error =>
                        {
                            self.loading = false;
                        });
                    }
                });
            },


            /*关闭弹窗*/
            dialogFormVisible() {
                this.$emit('closeDialog', {openDialog: false});
            },
            /*打开上传付款凭证图片*/
            openpayimageUpload: function() {
              this.ispayimageUpload = true;
            },
            /*上传付款凭证图片*/
            returnpayimageImgsFunc(e) {
              if (e != null) {
                e.forEach(item=>{
                  this.order.pay_image_url.push(item.file_path)
                })
              }
              this.ispayimageUpload = false;
            },

            /*删除付款凭证图片*/
            deleteImg(index) {
              this.order.pay_image_url.splice(index, 1);
            },
        }
    };
</script>

<style>

  .draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .draggable-list .wrapper > span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }

  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }

  .draggable-list .item:hover .delete-btn {
    display: block;
  }

  .draggable-list .item  el-image{
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }

  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }

  .draggable-list .img-select i {
    color: #409eff;
  }
</style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/PayImage.vue